import { createAction } from 'redux-actions';

import dynaForms from '@elab/core/utils/dynaForms';

import getTypes from './types';

const createActions = ({ storeName, parentStoreName }) => {
    const types = getTypes({ storeName, parentStoreName });
    const setPinCodeStatus = createAction(types.parent.SET_PIN_CODE_STATUS);
    const showPinCode = createAction(types.parent.SHOW_PINCODE);

    return {
        ...dynaForms.getActions(storeName),
        parent: {
            ...dynaForms.getActions(parentStoreName),
            setPinCodeStatus,
            showPinCode,
        },
    };
};

export default createActions;
